export default "__VITE_ASSET__39ace875__"